module.exports = __webpack_public_path__ + "img/1.a878f3b5.png";